import React from 'react'
import Header from './partials/Header';
import Footer from './partials/Footer';
import { Outlet } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';

// Adding 2 QueryClientProviders allows us to have different stale times for different queries.
// The long-lived one is used for the header and footer, which are not expected to change often.
// The short-lived one is used for the main content, which may change more frequently.
// This is useful for performance optimization, as it allows us to avoid unnecessary refetching of data.
const queryClientLongLived = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            refetchOnReconnect: false,
            staleTime:  1000 * 60 * 60 * 12, // 12 hours
        },
    },
});

const queryClientShortLived = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            refetchOnReconnect: false,
            staleTime:  1000 * 60 * 15, // 15 minutes
        },
    },
});

export default function BasePageLayout({ pageClassname = ''}) {    
    return (<site-wrapper class={(pageClassname === '') ? null : pageClassname}>
        <QueryClientProvider client={queryClientLongLived}>
            <Header />
        </QueryClientProvider>
        <hr className="header-divider"/>
        <main className="main-content" role="main">
            <QueryClientProvider client={queryClientShortLived}>
                <Outlet />
            </QueryClientProvider>
        </main>
        <QueryClientProvider client={queryClientLongLived}>
            <Footer />
        </QueryClientProvider>
    </site-wrapper>)
}
